// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v3.19.1
// source: status.proto

/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "hiber.status";

/** The maintenance modes */
export enum MaintenanceMode {
  /** NONE - System operating normally. */
  NONE = "NONE",
  /** RELEASE - Release is in progress, some customer operations may be blocked. */
  RELEASE = "RELEASE",
  /** READ_ONLY_PREPARATION - Preparing for full read-only mode. This blocks new requests but lets the ongoing ones be handled. */
  READ_ONLY_PREPARATION = "READ_ONLY_PREPARATION",
  /** READ_ONLY - Read-only mode. No changes can be made. */
  READ_ONLY = "READ_ONLY",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function maintenanceModeFromJSON(object: any): MaintenanceMode {
  switch (object) {
    case 0:
    case "NONE":
      return MaintenanceMode.NONE;
    case 1:
    case "RELEASE":
      return MaintenanceMode.RELEASE;
    case 2:
    case "READ_ONLY_PREPARATION":
      return MaintenanceMode.READ_ONLY_PREPARATION;
    case 3:
    case "READ_ONLY":
      return MaintenanceMode.READ_ONLY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MaintenanceMode.UNRECOGNIZED;
  }
}

export function maintenanceModeToNumber(object: MaintenanceMode): number {
  switch (object) {
    case MaintenanceMode.NONE:
      return 0;
    case MaintenanceMode.RELEASE:
      return 1;
    case MaintenanceMode.READ_ONLY_PREPARATION:
      return 2;
    case MaintenanceMode.READ_ONLY:
      return 3;
    case MaintenanceMode.UNRECOGNIZED:
    default:
      return -1;
  }
}

export interface MaintenanceStatus {
}

export interface MaintenanceStatus_Request {
}

export interface MaintenanceStatus_Response {
  maintenanceMode: MaintenanceMode;
}

function createBaseMaintenanceStatus(): MaintenanceStatus {
  return {};
}

export const MaintenanceStatus = {
  encode(_: MaintenanceStatus, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MaintenanceStatus {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMaintenanceStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<MaintenanceStatus>): MaintenanceStatus {
    return MaintenanceStatus.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<MaintenanceStatus>): MaintenanceStatus {
    const message = createBaseMaintenanceStatus();
    return message;
  },
};

function createBaseMaintenanceStatus_Request(): MaintenanceStatus_Request {
  return {};
}

export const MaintenanceStatus_Request = {
  encode(_: MaintenanceStatus_Request, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MaintenanceStatus_Request {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMaintenanceStatus_Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<MaintenanceStatus_Request>): MaintenanceStatus_Request {
    return MaintenanceStatus_Request.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<MaintenanceStatus_Request>): MaintenanceStatus_Request {
    const message = createBaseMaintenanceStatus_Request();
    return message;
  },
};

function createBaseMaintenanceStatus_Response(): MaintenanceStatus_Response {
  return { maintenanceMode: MaintenanceMode.NONE };
}

export const MaintenanceStatus_Response = {
  encode(message: MaintenanceStatus_Response, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.maintenanceMode !== MaintenanceMode.NONE) {
      writer.uint32(8).int32(maintenanceModeToNumber(message.maintenanceMode));
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MaintenanceStatus_Response {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMaintenanceStatus_Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.maintenanceMode = maintenanceModeFromJSON(reader.int32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<MaintenanceStatus_Response>): MaintenanceStatus_Response {
    return MaintenanceStatus_Response.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MaintenanceStatus_Response>): MaintenanceStatus_Response {
    const message = createBaseMaintenanceStatus_Response();
    message.maintenanceMode = object.maintenanceMode ?? MaintenanceMode.NONE;
    return message;
  },
};

/** Service to get system status. */
export type StatusServiceDefinition = typeof StatusServiceDefinition;
export const StatusServiceDefinition = {
  name: "StatusService",
  fullName: "hiber.status.StatusService",
  methods: {
    /** Get the current maintenance mode. */
    maintenance: {
      name: "Maintenance",
      requestType: MaintenanceStatus_Request,
      requestStream: false,
      responseType: MaintenanceStatus_Response,
      responseStream: false,
      options: {},
    },
  },
} as const;

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;
